// extracted by mini-css-extract-plugin
export var link = "VwKq2j1k92Ykq8Q7K_Bv";
export var root = "laJxoFFUXKLHxoextbfe";